import { FAILURE, SUCCESS } from "../../../../constants/BaseConstants";
import { SEARCH_PATH } from "../../../../constants/RoutesConstants";
import { call, put, select, all } from "redux-saga/effects";

import { GET_SEARCH_RESULTS } from "../../../../constants/SearchConstants";
import getSearchKeywordSelector from "./../../../selectors/SearchSelectors/getSearchKeywordSelector";
import getSearchResultsCall from "../../../../api/SearchCalls/getSearchResultsCall";
import { push } from "connected-react-router";

export default function* getSearchResultsSaga(): any {
    try {
        const keyword = yield select(getSearchKeywordSelector);
        const results = yield call(getSearchResultsCall, keyword);
        yield all([put({ type: GET_SEARCH_RESULTS + SUCCESS, results }), put(push(SEARCH_PATH))]);
        //yield put({ type: GET_SEARCH_RESULTS + SUCCESS, results });
    } catch (error) {
        yield put({ type: GET_SEARCH_RESULTS + FAILURE, error });
    }
}
